<div class="search-input-wrapper madar--v2">
  <form [formGroup]="form">
    <app-row [class]="showSearchActions || searchKeyItems.length ? null : 'no-gutters'">
      <app-col *ngIf="!multiple">
        <div class="flex box grow">
          <mat-form-field class="w-100" appearance="outline" [class.search-input-wrapper__right-position]="iconPosition === 'right'">
            <input
              class="custom-placeholder small"
              formControlName="searchTerm"
              matInput
              type="search"
              [placeholder]="placeholder"
              [type]="inputType"
            />

            <div matPrefix>
              <app-icon
                class="cursor-pointer icon mr-1"
                name="close-circle"
                size="xs"
                (click)="onClearButtonClicked()"
                *ngIf="form.value?.searchTerm"
              ></app-icon>
              <app-icon name="search" class="icon" size="xs"></app-icon>
            </div>
            <mat-error
              *ngIf="
                  form.invalid &&
                  form.get('searchTerm').touched &&
                form.get('searchTerm').hasError('whitespace') || form.get('searchTerm').hasError('pattern')"
            >
              {{ "ErrorMessages.InValidData" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </app-col>

      <app-col *ngIf="multiple" class="px-0">
        <div class="flex box grow">
          <mat-form-field
            class="form-field-with-chips w-100"
            appearance="outline"
            [class.search-input-wrapper__right-position]="iconPosition === 'right'"
          >
            <mat-chip-grid #chipList>
              <div
                class="chip-wrapper"
                [matTooltip]="showValueAsTooltip ? stringSearchValue : null"
                matTooltipPosition="above"
                [ngClass]="{'scrollable scrollable--x scroll-chip-wrapper': scrollInput}"
              >
                <ng-container *ngFor="let searchTerm of (form.value.searchTermList || [])">
                  <mat-chip-row *ngIf="searchTerm?.length" (removed)="removeSearch(searchTerm)">
                    <span [ngClass]="{'text-warn': notFoundValuesSet.has(searchTerm)}">{{searchTerm}}</span>
                    <button matChipRemove>
                      <app-icon name="cancel" type="MaterialDesign" size="xs"></app-icon>
                    </button>
                  </mat-chip-row>
                </ng-container>
              </div>

              <input
                #input
                [placeholder]="placeholder"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addSearchTerm($event, input)"
              />
            </mat-chip-grid>

            <div matPrefix>
              <app-icon
                class="cursor-pointer mr-1"
                name="close-circle"
                size="xs"
                (click)="onClearButtonClicked()"
                *ngIf="form.value?.searchTermList?.length"
              ></app-icon>
              <app-icon name="search" class="search-icon" size="xs"></app-icon>
            </div>
          </mat-form-field>
        </div>
      </app-col>

      <app-col *ngIf="searchKeyItems.length" class="px-0" cols="3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-select formControlName="searchKey">
            <mat-option *ngFor="let searchKeyItem of searchKeyItems" [value]="searchKeyItem">
              {{ "Enum.SearchKey." + searchKeyItem.dropDownDisplayName | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </app-col>

      <app-col class="pt-1" [cols]="ColsNumber" *ngIf="showSearchActions">
        <div class="action">
          <div class="col-auto">
            <button mat-flat-button [disabled]="form.invalid" color="primary" (click)="onSearchButtonClicked()" [ngStyle]="searchStyles">
              {{ buttonText | translate }}
            </button>
          </div>

          <!--          <div class="col-auto">-->
          <!--            <button mat-flat-button class="btn-secondary" (click)="onClearButtonClicked()">{{ "Buttons.Clear" | translate }}</button>-->
          <!--          </div>-->
        </div>
      </app-col>
    </app-row>
  </form>
</div>
